(function() {
  'use strict';

  function formatPrice(price) {
    let priceStr = String(price);
    priceStr = priceStr.replace(/,/g, '');
    
    if (priceStr.indexOf('.') === -1) {
      return priceStr;
    }
    
    const parts = priceStr.split('.');
    const wholePart = parts[0];
    let decimalPart = parts[1] || '';
    
    decimalPart = decimalPart.substring(0, 2);
    
    if (decimalPart === '00' || decimalPart === '0' || decimalPart === '') {
      return wholePart;
    }
    
    if (decimalPart.length === 1) {
      return wholePart + '.' + decimalPart;
    }
    
    return wholePart + '.' + decimalPart;
  }

  function formatAllPrivePrices() {
    const priceSpans = document.querySelectorAll('span[id*="price"]');
    
    priceSpans.forEach(function(span) {
      const text = span.textContent || span.innerText;
      const match = text.match(/\$([\d,]+\.?\d*)(\s*(USD|CAD))?/);
      
      if (match && match[1]) {
        const newText = '$' + formatPrice(match[1]);
        if (span.textContent !== newText) {
          span.textContent = newText;
        }
      }
    });
    
    const addToCartBtn = document.querySelector('button[class*="add-to-bag"]');
    if (addToCartBtn) {
      const btnText = addToCartBtn.textContent;
      const newText = btnText.replace(/\s*-\s*\$[\d,]+\.?\d*\s*(USD|CAD)?/g, '');
      if (addToCartBtn.textContent !== newText) {
        addToCartBtn.textContent = newText;
      }
    }
    
    const afterpayPrice = document.querySelector('span[class*="afterpay-price"]');
    if (afterpayPrice) {
      const text = afterpayPrice.textContent;
      const match = text.match(/\$([\d,]+\.?\d*)\s*(USD|CAD)/);
      
      if (match && match[1]) {
        const formatted = '$' + formatPrice(match[1]);
        const newText = text.replace(/\$([\d,]+\.?\d*)\s*(USD|CAD)/, formatted);
        afterpayPrice.textContent = newText;
      }
    }
  }

  function updatePrice() {
    const activeBox = document.querySelector('.prive_type_box_active');
    if (!activeBox) return;
    
    let newPrice = null;

    const priceSpan = activeBox.querySelector('span[id*="price"]');
    if (priceSpan) {
      const match = priceSpan.textContent.match(/\$?([\d,]+\.?\d*)/);
      if (match) {
        newPrice = match[1];
      }
    }
    
    if (!newPrice) {
      const spans = activeBox.querySelectorAll('span');
      for (const span of spans) {
        const match = (span.textContent || span.innerText).match(/\$?([\d,]+\.?\d*)/);
        if (match && match[1]) {
          newPrice = match[1];
          break;
        }
      }
    }
    
    if (newPrice) {
      const formattedPrice = formatPrice(newPrice);
      const costElements = document.querySelectorAll('component-pdp-product-info .js-cost');
      
      costElements.forEach(function(el) {
        if (el.textContent.includes('$')) {
          el.textContent = el.textContent.replace(/\$[\d,]+\.?\d*/g, '$' + formattedPrice);
        } else {
          el.textContent = '$' + formattedPrice;
        }
        
        if (el.innerHTML.includes('$')) {
          el.innerHTML = el.innerHTML.replace(/\$[\d,]+\.?\d*/g, '$' + formattedPrice);
        }
      });
    }
    
    formatAllPrivePrices();
  }

  function setupObservers() {
    const container = document.querySelector('#prive-widget-injection-point, [class*="prive"]');
    
    if (!container) {
      setTimeout(setupObservers, 500);
      return;
    }
    
    new MutationObserver(function() {
      formatAllPrivePrices();
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
    
    new MutationObserver(function(mutations) {
      const shouldUpdate = mutations.some(function(mutation) {
        return (mutation.attributeName === 'class' && 
                mutation.target.classList && 
                mutation.target.classList.contains('prive_type_box_active')) ||
               mutation.addedNodes.length > 0;
      });
      
      if (shouldUpdate) setTimeout(updatePrice, 150);
    }).observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    
    const handleChange = function() {
      setTimeout(updatePrice, 150);
    };
    
    const addListeners = function() {
      document.querySelectorAll('input[type="radio"][name*="type-"]').forEach(function(input) {
        input.removeEventListener('change', handleChange);
        input.removeEventListener('click', handleChange);
        input.addEventListener('change', handleChange);
        input.addEventListener('click', handleChange);
      });
    };
    
    addListeners();
    setInterval(addListeners, 1000);
    setInterval(formatAllPrivePrices, 100);
    
    formatAllPrivePrices();
    setTimeout(formatAllPrivePrices, 300);
    setTimeout(formatAllPrivePrices, 1000);
  }

  function init() {
    document.addEventListener('prive-widget-init', function() {
      setTimeout(setupObservers, 1000);
    });
    
    setTimeout(setupObservers, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();